import React, { useState } from "react";
import { Link } from "react-router-dom";

import TableRow from "./TableRow";
import Spinner from "../Spinner";
import Modal from "../Modal";
import { t } from "../../i18n/language";

export default function Table({
 bcQuery = [],
 amount = 10,
 noResultsMessage = t("No results found!"),
 linkText,
 linkTo,
}) {
 const [ratingModal, setRatingModal] = useState(false);

 return (
  <div className="mt-2 bg-white rounded border border-gray-200">
   <div className="flex justify-end md:grid md:grid-cols-9 border-b border-gray-200 text-center text-xs text-gray-600 items-center">
    <div className="md:col-span-4">&nbsp;</div>

    {/* Rating */}
    <div className="mr-4 md:mr-0 px-2 py-2 cursor-pointer">
     <button
      onClick={() => setRatingModal(true)}
      className="text-gray-600 text-xs md:text-xxs lg:text-xs font-semibold uppercase border-b border-gray-200 focus:outline-none focus:border-gray-500 hover:border-gray-500"
     >
      {t("Rating")}
     </button>
    </div>
    {/* SUBTITLES AND CAPTIONS */}

    <div
     className="px-2 py-2 justify-center relative tooltip hidden md:flex"
     data-tooltip={`${t("Subtitles")} / ${t("Captions")}`}
    >
     <svg
      className="w-5 h-5"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
     >
      <path d="M15 14.5H5v-1.667h10V14.5zM17 3c.53 0 1.04.176 1.414.488.375.313.586.737.586 1.179v11.666c0 .925-.89 1.667-2 1.667H3a2.22 2.22 0 01-1.414-.488C1.21 17.199 1 16.775 1 16.333V4.667C1 3.742 1.89 3 3 3h14zM3 4.667v11.666h14V4.667H3z" />
     </svg>
    </div>
    {/* TRANSCRIPTION */}
    <div
     className="px-2 py-2 justify-center relative tooltip hidden md:flex"
     data-tooltip={t("Transcription")}
    >
     <svg
      className="w-5 h-5"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
     >
      <path d="M13.333 12.5H7.5v-1.667h5.833V12.5zm2.5-3.333H7.5V7.5h8.333v1.667zm0-3.334H7.5V4.167h8.333v1.666zM2.5 4.167V17.5h13.333v1.667H2.5A1.667 1.667 0 01.833 17.5V4.167H2.5zm15-3.334A1.667 1.667 0 0119.167 2.5v11.667c0 .925-.742 1.666-1.667 1.666H5.833a1.667 1.667 0 01-1.666-1.666V2.5A1.66 1.66 0 015.833.833H17.5zM5.833 2.5v11.667H17.5V2.5H5.833z" />
     </svg>
    </div>
    {/* AUDIO DESCRIPTION */}
    <div
     className="px-2 py-2 justify-center relative tooltip hidden md:flex"
     data-tooltip={t("Audio description")}
    >
     <svg
      className="w-5 h-5"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
     >
      <path d="M10.036 19.542c-3.433-.09-5.298-1.944-7.025-4.255 1.67-2.493 3.808-4.02 7.014-4.084 3.16.058 5.47 2.465 6.804 4.101-1.372 2.392-3.756 4.161-6.793 4.238zm-.014-1.256c1.63.032 2.967-1.48 2.914-3.015.05-1.439-1.264-2.804-2.914-2.762C8.2 12.463 6.936 13.8 6.98 15.27c-.036 1.498 1.322 3.053 3.041 3.017zM4.963 8.992c1.329-1.688 3.317-2.33 5.055-2.335 1.855.108 3.588.809 4.942 2.32l-1.084.922c-1.152-1.126-2.364-1.74-3.872-1.795-1.53.018-2.738.492-3.938 1.796l-1.103-.908zM2.955 6.869C5.32 4.284 7.576 3.742 10.02 3.677c2.49.03 5.245 1.22 6.963 3.225l-1.088.942c-1.696-1.74-3.418-2.744-5.874-2.707-2.424-.002-4.437 1.035-5.995 2.7l-1.07-.966zM.904 4.812C3.747 1.635 6.813.707 10.006.657c3.7.095 6.884 1.574 8.997 4.118l-1.088.992c-2.176-2.502-5.106-3.511-7.899-3.629-3.547-.032-5.735 1.277-7.982 3.624L.904 4.81z" />
     </svg>
    </div>
    {/* SIGN LANGUAGE */}
    <div
     className="px-2 py-2 justify-center relative tooltip hidden md:flex"
     data-tooltip={t("Sign language")}
    >
     <svg
      className="w-5 h-5"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
     >
      <path d="M6.01 18.912a.744.744 0 01-.366-.346.745.745 0 01.007-.602c.149-.304.402-.41 1.456-.616.556-.108 2.064-.46 2.175-.508.184-.08.257-.18.21-.292-.077-.187-.326-.168-2.779.214-1.687.263-1.992.275-2.29.095-.163-.1-.243-.248-.259-.482-.025-.368.115-.592.444-.709.212-.074.322-.095.8-.15.21-.025.697-.09 1.08-.148 1.338-.197 1.758-.255 2.082-.29.555-.062.743-.137.743-.3 0-.07-.093-.137-.225-.166-.136-.029-.398-.021-1.216.034-.278.02-.947.06-1.485.091a381.3 381.3 0 00-1.573.094c-.632.04-.982.033-1.16-.022-.258-.08-.391-.255-.413-.542-.035-.47.196-.711.775-.812.107-.019.443-.044.748-.057.304-.013 1.03-.054 1.611-.09a71.424 71.424 0 011.7-.09c.65-.02.827-.04.942-.099.195-.1.149-.294-.083-.35-.066-.015-.497-.028-1.163-.033a43.4 43.4 0 01-1.474-.033c-.23-.013-.71-.034-1.07-.047-.891-.032-1.063-.065-1.254-.243-.128-.12-.175-.25-.175-.48 0-.197.062-.367.174-.474.107-.104.19-.145.407-.203.17-.046.205-.047 2.91-.042 2.887.005 2.915.004 3.094-.097.184-.105.223-.348.097-.602-.076-.153-.103-.182-.899-.957-.44-.43-.604-.637-.695-.88-.134-.356-.147-.72-.034-.973.073-.16.218-.303.35-.343.099-.03-.05-.125 1.608 1.04 1.298.911 1.703 1.192 2.353 1.63.291.197.67.46.844.585.368.265.732.488.897.55.261.097.715.115 1.484.057.464-.035 1.22-.033 1.373.004l.062.015V16.274l-.095.013c-.1.013-1.398.11-1.998.15-.53.035-.611.065-1.018.374-.49.373-1.16.65-2.134.886-.205.05-1.354.288-2.554.53-1.2.243-2.496.507-2.88.587-.774.162-.933.175-1.134.098zm.66-8.462c-.257-.026-.6-.104-1.085-.222-.187-.087-.585-.098-1.303-.4-1.488-.629-1.667-.712-1.826-.852-.432-.378-.182-1.093.404-1.154.156-.016.32.028.752.205.195.08.74.281 1.21.448.47.167.972.352 1.114.411.2.082.296.11.42.117.148.01.162.007.196-.042.135-.192-.087-.39-.762-.68-.186-.08-.799-.374-1.362-.651a87.42 87.42 0 00-1.26-.614c-.56-.255-.65-.304-.778-.42-.17-.157-.235-.293-.236-.499 0-.362.287-.679.642-.707.233-.02.464.063.957.343.092.053.518.261.945.464a80.6 80.6 0 011.508.736c.76.384.924.455 1.05.455.1 0 .166-.067.166-.168 0-.11-.097-.212-.298-.317-.2-.104-.84-.48-2.36-1.385a82.373 82.373 0 00-1.419-.832c-.59-.321-.77-.52-.772-.855a.693.693 0 01.182-.496c.143-.16.248-.208.471-.22.295-.016.45.05 1.013.43.172.117.865.534 1.54.927.675.394 1.353.797 1.508.896.402.258.654.376.8.376.135 0 .19-.044.19-.15 0-.149-.204-.328-.731-.637-.223-.131-.38-.241-1.52-1.07-.427-.312-1.05-.749-1.05-.749-.36-.242-.538-.407-.62-.58a.72.72 0 01.299-.923c.111-.061.14-.067.336-.067.189 0 .228.007.333.062.066.034.178.106.248.16.262.201 4.493 3.014 4.583 3.046a.5.5 0 00.372-.029.418.418 0 00.118-.13c.048-.084.053-.117.05-.374-.002-.293-.023-.424-.201-1.25-.176-.815-.094-1.37.254-1.713.228-.212.435-.259.666-.23.253.15.027-.125 1.486 3.542.241.607.536 1.334.655 1.615.118.282.261.636.317.788.17.461.249.546.8.867.348.203.64.396.94.619l.208.156.102.754.086.858h-.736l-.257-.161c-.75-.469-1.61-1.163-3.386-2.316-1.353-.879-1.781-1.255-2.266-1.459-.486-.281-1.323.927-1.465 1.403-.052.173-.052.527 0 .74.114.475.459.956 1.18 1.646.223.215.106.252.106.284 0 .006-.216 0-.919.008-.703.007-.936 0-1.103.006-.167.005-.389 0-.493-.01z" />
     </svg>
    </div>
   </div>

   {bcQuery === "no results found" ? (
    <div className="py-6 px-4 text-sm text-gray-700">
     {noResultsMessage}{" "}
     {linkText && linkTo ? (
      <Link
       to={linkTo}
       className="border-b border-gray-200 hover:border-gray-500 focus:border-gray-500"
      >
       {linkText}
      </Link>
     ) : null}
    </div>
   ) : bcQuery.length > 0 ? (
    bcQuery.map((result, i) => {
     if (i < amount) {
      return <TableRow key={result.id} result={result} />;
     } else return null;
    })
   ) : (
    <div className="py-6 px-4 text-sm">
     <Spinner />
    </div>
   )}

   {/* RATING MODAL */}
   <Modal
    title={t("Accessibility rating")}
    width="w-96"
    acceptButtonText={t("Close")}
    show={ratingModal}
    onAccept={() => setRatingModal(false)}
    onClose={() => setRatingModal(false)}
   >
    <h3 className="font-semibold">{t("Rating")}: A</h3>
    <p className="mt-2 text-xs">
     {t("You should have at least one of the following...")}
    </p>
    <ul className="mt-1 text-xs list-inside">
     <li>&bull; {t("Subtitles")}</li>
     <li>&bull; {t("Captions")}</li>
     <li>&bull; {t("Transcript")}</li>
     <li>&bull; {t("Audio description")}</li>
    </ul>
    <h3 className="mt-2 font-semibold">{t("Rating")}: AA</h3>
    <p className="mt-2 text-xs">
     {t("You should have all of the following...")}
    </p>
    <ul className="mt-1 text-xs list-inside">
     <li>
      &bull; {t("Subtitles")} <span className="uppercase">{t("Or")} </span>
      {t("Captions")}
     </li>
     <li>&bull; {t("Transcript")}</li>
     <li>&bull; {t("Audio description")}</li>
    </ul>
    <h3 className="mt-2 font-semibold">{t("Rating")}: AAA</h3>
    <p className="mt-2 text-xs">
     {t("You should have all of the following...")}
    </p>
    <ul className="mt-1 text-xs list-inside">
     <li>
      &bull; {t("Subtitles")} <span className="uppercase">{t("Or")} </span>
      {t("Captions")}
     </li>
     <li>&bull; {t("Transcript")}</li>
     <li>&bull; {t("Audio description")}</li>
     <li>&bull; {t("Sign language")}</li>
    </ul>
   </Modal>
  </div>
 );
}
